import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kodit-moj-profil-page',
  templateUrl: './moj-profil-page.component.html',
  styleUrls: ['./moj-profil-page.component.scss']
})
export class MojProfilPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
